import { PageHero } from '@/components/common/PageHero';

export function ServicesHero() {
  return (
    <PageHero
      eyebrow="Helmflex / Usluge"
      title="Naše usluge"
      description="Planiranje, koordinacija i operativna podrška za mala i srednja preduzeća koja sprovode važan poslovni projekat."
    />
  );
}
